export const NEWBUILDING_KPN_CHAT = 'newbuilding_kpn_chats_jk_desktop';

export const NEWBUILDING_CONFIDENT_BOOKING_CARDJK_WEB = 'newbuilding_confident_booking_cardjk_web';

export const NEWBUILDING_PURCHASE_GIFT_EXPERIMENT = 'newbuilding_benefits_on_apartments';

export const EXPERIMENTS = [
  NEWBUILDING_KPN_CHAT,
  NEWBUILDING_CONFIDENT_BOOKING_CARDJK_WEB,
  NEWBUILDING_PURCHASE_GIFT_EXPERIMENT,
];
